import React, { useState } from 'react'
import Cookies from 'js-cookie'
import { sha256 } from '../../../global/authentication/authentication-manager.js'
import { BaseForm } from './BaseForm/BaseForm.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { postJsonRawResponse } from '../../../global/data/service'
import { InputGroup } from './formInputs/index.jsx'
import { getFormConfig } from './formConfig.js'
import { getServiceType, createEmailPayload } from './formServices.js'
import { getLongTermCookieOptions } from '../../../global/environments/config.js'

const Headline = ({ title }) => {
  return (
    <div className="u-flex u-flexJustifyStart u-paddingVert10gu u-bgColorBrand">
      <h1 className="u-sizeConstrained u-textColorWhite">{title}</h1>
    </div>
  )
}

/* returns a list of invalid fields */
const validate = (userInput, inputs) => {
  const invalid = Object.keys(userInput).filter((key) => {
    const value = userInput[key]
    const validator = inputs.find((input) => input.name === key)?.validator
    /* if no validator, assume valid */
    if (!validator) return false
    return !validator(value)
  })

  return invalid
}

const getInputsMap = (inputs) => {
  return inputs.reduce((acc, input) => {
    acc[input.name] = null
    return acc
  }, {})
}

const getColumns = (inputs) => (group) => {
  return inputs.find((input) => input.name === group)
}

const Form = () => {
  // hard coded to Ria Contact for now
  const { strings, inputs, columns } = getFormConfig('Ria Contact')
  const inputsMap = getInputsMap(inputs)
  const [userInput, setUserInput] = useState(inputsMap)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [errors, setErrors] = useState({ inputsMap })

  const service = getServiceType('?service=ria_sales_inquiries')

  const column1 = columns[0].map(getColumns(inputs))
  const column2 = columns[1].map(getColumns(inputs))

  const inputChangeHandler = (e, input) => {
    setUserInput({
      ...userInput,
      [input]: e.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    setErrors(inputsMap)
    const e = {}

    const validationErrors = validate(userInput, inputs)
    validationErrors.forEach((el) => {
      return (e[el] = true)
    })

    if (validationErrors.length) {
      setErrors(e)
    } else {
      const response = await postJsonRawResponse(
        strings.url,
        createEmailPayload(service, userInput)
      )
      setIsSuccess(response.ok)
      setIsSubmitted(true)

      if (strings.formId === 'RiaContactForm') {
        try {
          sha256(userInput.email).then(function (data) {
            if (!Cookies.get('CTN_UID') && !localStorage.getItem('CTN_UID')) {
              localStorage.setItem('CTN_UID', data)

              Cookies.set('CTN_UID', data, {
                ...getLongTermCookieOptions(),
                secure: true,
              })
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    }
  }

  const renderInput = (input) => {
    const Component = input.component
    return (
      <div className="u-marginTop3gu" key={input.name}>
        <InputGroup
          name={input.name}
          label={input.label}
          error={errors[input.name]}
          hideErrorIcon={input.hideErrorIcon}
          errorMessage={input.errorMessage}
          required={input.required}
          onChange={(e) => {
            inputChangeHandler(e, input.name)
          }}
          render={(props) => <Component {...props} />}
          options={input.options || []}
        />
      </div>
    )
  }

  return (
    <BaseForm
      isSubmitted={isSubmitted}
      isSuccess={isSuccess}
      headline={Headline({ title: strings.title })}
      subtitle={strings.subtitle}
    >
      <form onSubmit={(e) => handleSubmit(e)} id={strings.formId}>
        <div className="u-flex u-sm-flexCol">
          <div className="u-size1of2 u-sm-sizeFull u-paddingRight5gu u-sm-paddingRight0">
            {column1.map(renderInput)}
          </div>
          <div className="u-size1of2 u-sm-sizeFull">
            {column2.map(renderInput)}
          </div>
        </div>
        <div className="u-marginTop5gu">
          <button
            className="Button Button--primary"
            type="submit"
            data-analytics={`cti-${strings.dataAnalyticsFormName}-form-submit-btn`}
          >
            Submit
          </button>
        </div>
      </form>
    </BaseForm>
  )
}
export function ContactForm(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        isProduction() ? null : <p>Error in CTA component</p>
      }
    >
      <Form {...props}></Form>
    </ErrorBoundary>
  )
}
